// src/careComponents/components/ReferrerChatDialog.tsx
import * as React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChatPane from "./chatPane";

type ViewerRole = "AGENT" | "PROVIDER" | "REFERRER";

type Props = {
  open: boolean;
  onClose: () => void;
  leadId: string | number | null;
  referrerName?: string | null;
  /** Who is viewing this dialog (controls left/right alignment) */
  viewerRole?: ViewerRole; // default "REFERRER"
};

export default function ReferrerChatDialog({
  open,
  onClose,
  leadId,
  referrerName,
  viewerRole = "REFERRER",
}: Props) {
  if (!leadId) return null;

  const title = referrerName
    ? `Agent ↔ Referrer — ${referrerName}`
    : "Agent ↔ Referrer";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        Conversation — Care Team
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
          size="small"
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {/* Show the referrer ↔ agent thread only */}
        <ChatPane
          leadId={String(leadId)}
          audience="REFERRER"      // lane = agent ↔ referrer
          viewerRole={viewerRole}
          title={title}
          height={520}
          pollMs={4000}
          // disableSubscription
        />
      </DialogContent>
    </Dialog>
  );
}
